module.exports = __webpack_public_path__ + "static/media/161-south-sudan.e0ffeabe.svg";